import axios from "axios";

export let headers = {
  "Tenant-Access-Token": "NjExODA4NjIzMWYwYzdjZDEwOGQwMTM3NDM2ZjEwZDc=",
  "Tenant-Access-Key": "OAG_hIG59CCO1A",
};

export const api = axios.create({
  baseURL: "https://tiltlabs-dev.confirmu.com",
  headers: {
    "Tenant-Access-Token": "NjExODA4NjIzMWYwYzdjZDEwOGQwMTM3NDM2ZjEwZDc=",
    "Tenant-Access-Key": "OAG_hIG59CCO1A",
  },
});

export const BASE_URL = "https://tiltlabs-dev.confirmu.com";
